import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { BRAND } from "@/config/brand";

export default function Terms() {
    return (
        <div>
            <PageMeta title="Terms & Conditions — YS Removals" description="Terms and conditions for the YS Removals website and services." canonical={`https://${BRAND.domain}/terms`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Terms & Conditions" }]} />
                    <h1 className="mt-3 text-4xl font-semibold font-heading">Terms & Conditions</h1>
                </div>
            </section>
            <section className="container-ys section prose prose-neutral max-w-3xl">
                <p>By using our website you agree to these terms. This is a placeholder terms and conditions document and should be replaced with legal wording specific to YS Removals.</p>
                <h2>Quotations and bookings</h2>
                <p>Quotations are based on the information you provide. Final pricing is confirmed before booking.</p>
                <h2>Liability</h2>
                <p>We aim to handle your belongings with care. Any specific liability terms will be shared before you book your move.</p>
            </section>
        </div>
    );
}
